import { isEqual, pick } from 'lodash';
import { StudioCell } from '../studio.types';
import { FAILSAFE_SCHEMA } from 'js-yaml';

export const fullWidth = {
  x: 0,
  y: 0,
  w: 1,
  h: 1,
  padding: 0,
};

export const isFullWidth = (cell: StudioCell) =>
  isEqual(fullWidth, pick(cell, ['x', 'y', 'w', 'h']));

export const center09 = {
  ...fullWidth,
  padding: 0.05,
};

export const center08 = {
  x: 0.1,
  y: 0.1,
  w: 0.8,
  h: 0.8,
};

export const center075 = {
  x: 0.125,
  y: 0.125,
  w: 0.75,
  h: 0.75,
  padding: 0,
};

export const center07 = {
  x: 0.15,
  y: 0.25,
  w: 0.7,
  h: 0.5,
  padding: 0,
};

export const center06 = {
  x: 0.2,
  y: 0.2,
  w: 0.6,
  h: 0.6,
};

export const center05 = {
  x: 0.25,
  y: 0.25,
  w: 0.5,
  h: 0.5,
  padding: 0,
};

export const center04 = {
  x: 0.3,
  y: 0.25,
  w: 0.4,
  h: 0.5,
  padding: 0,
};

export const center03 = {
  x: 0.35,
  y: 0.3,
  w: 0.3,
  h: 0.4,
  padding: 0,
};

// export const center09 = {
//   ...fullWidth,
//   padding: 0.05,
// };

// export const center08 = {
//   ...fullWidth,
//   padding: 0.1,
// };

export const _leftHalf = (
  padding = 0.05,
  align: 'left' | 'center' | 'right' = 'left',
): StudioCell => ({
  x: 0,
  y: 0,
  w: 0.5,
  h: 1,
  align,
  padding,
});

export const _rightHalf = (
  padding = 0.05,
  align: 'left' | 'center' | 'right' = 'right',
): StudioCell => ({
  x: 0.5,
  y: 0,
  w: 0.5,
  h: 1,
  align,
  padding,
});

export const leftHalf: StudioCell = {
  x: 0,
  y: 0,
  w: 0.5,
  h: 1,
  align: 'left',
  padding: 0.05,
};

export const isLeftHalf = (cell: StudioCell) =>
  isEqual(leftHalf, pick(cell, ['x', 'y', 'w', 'h']));
export const rightHalf: StudioCell = {
  x: 0.5,
  y: 0,
  w: 0.5,
  h: 1,
  align: 'right',
  padding: 0.05,
};

export const isRightHalf = (cell: StudioCell) =>
  isEqual(rightHalf, pick(cell, ['x', 'y', 'w', 'h']));

export const rightBottomQuarter = {
  x: 0.5,
  y: 0.5,
  w: 0.5,
  h: 0.5,
};

export const isRightBottomQuarter = (cell: StudioCell) =>
  isEqual(rightBottomQuarter, pick(cell, ['x', 'y', 'w', 'h']));

export const rightTopQuarter = {
  x: 0.5,
  y: 0,
  w: 0.5,
  h: 0.5,
};

export const isRightTopQuarter = (cell: StudioCell) =>
  isEqual(rightTopQuarter, pick(cell, ['x', 'y', 'w', 'h']));

export const leftTopQuarter = {
  x: 0,
  y: 0,
  w: 0.5,
  h: 0.5,
};

export const letfTop = (
  type?: 'third' | 'half' | 'twoThird',
  overflow = FAILSAFE_SCHEMA,
): StudioCell => ({
  x: 0,
  y: overflow ? -0.1 : 0,
  w: type === 'third' ? 0.33 : type === 'half' ? 0.5 : 0.66,
  h: type === 'third' ? 0.33 : type === 'half' ? 0.5 : 0.66,
  align: 'left',
  padding: 0.05,
});

export const leftBottom = (
  type?: 'third' | 'half' | 'twoThird',
  overflow = false,
): StudioCell => ({
  x: 0,
  y: overflow ? 0.6 : 0,
  w: type === 'third' ? 0.33 : type === 'half' ? 0.5 : 0.66,
  h: type === 'third' ? 0.33 : type === 'half' ? 0.5 : 0.66,
  align: 'left',
  padding: 0.05,
});

export const isLeftTopQuarter = (cell: StudioCell) =>
  isEqual(leftTopQuarter, pick(cell, ['x', 'y', 'w', 'h']));

export const leftBottomQuarter = {
  x: 0,
  y: 0.5,
  w: 0.5,
  h: 0.5,
};

export const isLeftBottomQuarter = (cell: StudioCell) =>
  isEqual(leftBottomQuarter, pick(cell, ['x', 'y', 'w', 'h']));

export const centerQuarter = {
  x: 0.25,
  y: 0.25,
  w: 0.5,
  h: 0.5,
};

export const isCenterQuarter = (cell: StudioCell) =>
  isEqual(centerQuarter, pick(cell, ['x', 'y', 'w', 'h']));

export const leftTopThird = {
  x: 0,
  y: 0,
  w: 0.5,
  h: 0.33,
};

export const isLeftTopThird = (cell: StudioCell) =>
  isEqual(leftTopThird, pick(cell, ['x', 'y', 'w', 'h']));

export const leftCenterThird = {
  x: 0,
  y: 0.33,
  w: 0.33,
  h: 0.33,
};

export const isLeftCenterThird = (cell: StudioCell) =>
  isEqual(leftCenterThird, pick(cell, ['x', 'y', 'w', 'h']));

export const leftBottomThird = {
  x: 0,
  y: 0.66,
  w: 0.5,
  h: 0.33,
};

export const isLeftBottomThird = (cell: StudioCell) =>
  isEqual(leftBottomThird, pick(cell, ['x', 'y', 'w', 'h']));

export const centerTopThird = {
  x: 0.33,
  y: 0,
  w: 0.33,
  h: 0.33,
};

export const isCenterTopThird = (cell: StudioCell) =>
  isEqual(centerTopThird, pick(cell, ['x', 'y', 'w', 'h']));

export const centerCenterThird = {
  x: 0.25,
  y: 0.33,
  w: 0.5,
  h: 0.33,
};

export const isCenterCenterThird = (cell: StudioCell) =>
  isEqual(centerCenterThird, pick(cell, ['x', 'y', 'w', 'h']));

export const centerBottomThird = {
  x: 0.33,
  y: 0.66,
  w: 0.5,
  h: 0.33,
};

export const isCenterBottomThird = (cell: StudioCell) =>
  isEqual(centerBottomThird, pick(cell, ['x', 'y', 'w', 'h']));

export const rightTopThird = {
  x: 0.5,
  y: 0,
  w: 0.5,
  h: 0.33,
};

export const rightCenterThird = {
  x: 0.5,
  y: 0.33,
  w: 0.5,
  h: 0.33,
};

export const isRightCenterThird = (cell: StudioCell) =>
  isEqual(rightCenterThird, pick(cell, ['x', 'y', 'w', 'h']));

export const rightBottomThird = {
  x: 0.5,
  y: 0.66,
  w: 0.5,
  h: 0.33,
};

export const isRightBottomThird = (cell: StudioCell) =>
  isEqual(rightBottomThird, pick(cell, ['x', 'y', 'w', 'h']));

export const rightBottom = (
  type?: 'third' | 'half' | 'twoThird',
  overflow = false,
): StudioCell => ({
  x: type === 'third' ? 0.66 : type === 'half' ? 0.5 : 0.33,
  y: overflow ? 0.5 : 0.5,
  w: type === 'third' ? 0.33 : type === 'half' ? 0.5 : 0.66,
  h: type === 'third' ? 0.33 : type === 'half' ? 0.5 : 0.66,
  align: 'right',
  padding: 0.05,
});

export const rightTop = (
  type?: 'third' | 'half' | 'twoThird',
  overflow = false,
): StudioCell => ({
  x: type === 'third' ? 0.66 : type === 'half' ? 0.5 : 0.33,
  y: overflow ? -0.2 : 0,
  w: type === 'third' ? 0.33 : type === 'half' ? 0.5 : 0.66,
  h: type === 'third' ? 0.33 : type === 'half' ? 0.5 : 0.66,
  align: 'right',
  padding: 0.05,
});

// Top and Bottom Halves
export const topHalf = {
  x: 0,
  y: 0,
  w: 1,
  h: 0.5,
};

export const isTopHalf = (cell: StudioCell) =>
  isEqual(topHalf, pick(cell, ['x', 'y', 'w', 'h']));

export const centerTopHalf = {
  x: 0.25,
  y: 0,
  w: 0.5,
  h: 0.5,
};

export const isCenterTopHalf = (cell: StudioCell) =>
  isEqual(centerTopHalf, pick(cell, ['x', 'y', 'w', 'h']));

export const centerBottomHalf = {
  x: 0.25,
  y: 0.5,
  w: 0.5,
  h: 0.5,
};

export const isCenterBottomHalf = (cell: StudioCell) =>
  isEqual(centerBottomHalf, pick(cell, ['x', 'y', 'w', 'h']));

export const bottomHalf = {
  x: 0,
  y: 0.5,
  w: 1,
  h: 0.5,
};

export const isBottomHalf = (cell: StudioCell) =>
  isEqual(bottomHalf, pick(cell, ['x', 'y', 'w', 'h']));

// Horizontal Thirds (full width, divided vertically)
export const topThird = {
  x: 0,
  y: 0,
  w: 1,
  h: 0.33,
};

export const isTopThird = (cell: StudioCell) =>
  isEqual(topThird, pick(cell, ['x', 'y', 'w', 'h']));

export const middleThird = {
  x: 0,
  y: 0.33,
  w: 1,
  h: 0.33,
};

export const isMiddleThird = (cell: StudioCell) =>
  isEqual(middleThird, pick(cell, ['x', 'y', 'w', 'h']));

export const bottomThird = {
  x: 0,
  y: 0.66,
  w: 1,
  h: 0.33,
};

export const isBottomThird = (cell: StudioCell) =>
  isEqual(bottomThird, pick(cell, ['x', 'y', 'w', 'h']));

// Vertical Thirds (full height, divided horizontally)
export const leftVerticalThird = {
  x: 0,
  y: 0,
  w: 0.33,
  h: 1,
};

export const isLeftVerticalThird = (cell: StudioCell) =>
  isEqual(leftVerticalThird, pick(cell, ['x', 'y', 'w', 'h']));

export const centerVerticalThird = {
  x: 0.33,
  y: 0,
  w: 0.33,
  h: 1,
};

export const isCenterVerticalThird = (cell: StudioCell) =>
  isEqual(centerVerticalThird, pick(cell, ['x', 'y', 'w', 'h']));

export const rightVerticalThird = {
  x: 0.66,
  y: 0,
  w: 0.33,
  h: 1,
};

export const isRightVerticalThird = (cell: StudioCell) =>
  isEqual(rightVerticalThird, pick(cell, ['x', 'y', 'w', 'h']));

// Two-thirds combinations
export const leftTwoThirds = {
  x: 0,
  y: 0,
  w: 0.66,
  h: 1,
};

export const isLeftTwoThirds = (cell: StudioCell) =>
  isEqual(leftTwoThirds, pick(cell, ['x', 'y', 'w', 'h']));

export const rightTwoThirds = {
  x: 0.33,
  y: 0,
  w: 0.66,
  h: 1,
};

export const isRightTwoThirds = (cell: StudioCell) =>
  isEqual(rightTwoThirds, pick(cell, ['x', 'y', 'w', 'h']));

export const topTwoThirds = {
  x: 0,
  y: 0,
  w: 1,
  h: 0.66,
};

export const isTopTwoThirds = (cell: StudioCell) =>
  isEqual(topTwoThirds, pick(cell, ['x', 'y', 'w', 'h']));

export const bottomTwoThirds = {
  x: 0,
  y: 0.33,
  w: 1,
  h: 0.66,
};

export const isBottomTwoThirds = (cell: StudioCell) =>
  isEqual(bottomTwoThirds, pick(cell, ['x', 'y', 'w', 'h']));
export const isRightTopThird = (cell: StudioCell) =>
  isEqual(rightTopThird, pick(cell, ['x', 'y', 'w', 'h']));
